<component v-if="editing" is="field-read" v-bind="props"></component><component v-else="editing" is="field-edit" v-bind="props"></component>